import React, { useState } from 'react'
import { FcSearch } from "react-icons/fc";
import axios from 'axios';
import { data } from 'autoprefixer';
import ".//style.css"
export default function Weather() {
    // const dateBuilder=(d)=>{
    //     let months =["January", "February", "March", "April", "May", "June", "July",  "August", "September", "October", "November",  "December"];
    //     let days =["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",  "Sunday"];

    //     let day =days[data.getDay()];
    //     let date = d.getDate();
    //     let month =months[d.getMonth()];
    //     let year = d.getFullYear();

    //     return `${day} ${date} ${month} ${year}`
    //     console.log(dateBuildernew Date())
    // }
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const d = new Date();
    let day = weekday[d.getDay()];
    console.log(day)

    const [city, setCity] = useState("Mumbai")
    const [data, setData] = useState({
        desc: "",
        temp: 0,
        humidity: 0,
        country: "",
        name: ""
    })
    const handleClick = () => {
        axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=fcff74639459107ee106ecfa9027a433`)
            .then((response) => {
                console.log(response)
                setData({
                    desc: response.data.weather[0].description,
                    temp: response.data.main.temp,
                    humidity: response.data.main.humidity,
                    country: response.data.sys.country,
                    name: response.data.name
                })
            })
    }
    return (
        <div className=' md:h-screen h-[1000px]  md:w-screen px-3  md:p-4 main'>

            <h5 className='text-white text-[34px] text-center uppercase'>Weather App</h5>
            <div className='bg-white md:w-96   py-2 md:ml-[430px] mt-5 rounded-md flex items-center md:gap-10 ms:gap-10 '>
                <input type="text" placeholder='Enter Your Location..' value={city} onChange={(e) => {
                    setCity(e.target.value);
                }} className='text-xl border-b p-1 border-gray-200 font-semibold uppercase' />
                <FcSearch className='text-[34px] cursor-pointer' onClick={handleClick} />
            </div>


            <div className='  md:p-7  text-white rounded-md mt-8 '>
                <div className='flex flex-col'>

                    <span className='text-center text-black md:text-white font-semibold text-[32px] city'>{data.name},{data.country}</span>
                    <span className=' text-center text-black date' id='date'>{day}</span>
                    <span className='temp text-[62px]'>{data.temp}° C</span>
                    <span className='weather capitalize'>{data.desc}</span>
                </div>
            </div>


        </div>

    )

}
